<!--蜂助手活动通用登录页面与接口-->
<!--大部分情况下，拿这个引用一下就可以用了-->
<!--普通情况，成功返回：onSuccessLogin({token/userId/mobile}) -->
<template>
  <div class="fzs-login-box">
    <div class="flb-form">
      <div class="flb-row flb-row-input">
        <div class="flb-icon flb-icon-phone">
          <img alt="" src="./mobile.svg"/>
        </div>
        <div class="flb-input">
          <input type="tel" placeholder="请输入您的手机号" maxlength="11" v-model="mobile">
        </div>
      </div>

      <div class="flb-row flb-row-input" v-if="graphImgKey">
        <div class="flb-icon flb-icon-graph">
          <img alt="" src="./img.svg"/>
        </div>
        <div class="flb-input">
          <input type="text" placeholder="请输入图形验证码" maxlength="6" v-model="graphCode">
        </div>
        <div class="flb-graph" @click="getGraphImg">
          <img :src="graphImg" alt="">
        </div>
      </div>

      <div class="flb-row flb-row-input">
        <div class="flb-icon flb-icon-code">
          <img alt="" src="./sms.svg"/>
        </div>
        <div class="flb-input">
          <input type="tel" placeholder="请输入验证码" maxlength="6" v-model="smsCode">
        </div>
        <div class="flb-action">
          <button @click="sendSmsCode" :disabled="getVerifyBtnDisabled"> {{ intervalTxt + (interval ? 's' : '') }} </button>
        </div>
      </div>

      <div class="flb-row flb-row-no-border flb-row-protocol" >
        <div class="flb-icon flb-icon-check" @click="toggleProtocolChecked">
          <img alt="" src="./check.svg" v-if="!protocolChecked" />
          <img alt="" src="./checked.svg" v-if="protocolChecked" />
        </div>
        <div class="protocol-href">
          <span @click="toggleProtocolChecked">我已阅读并同意</span>
          <a :href="agreementUrl">《隐私政策》</a>
          <a :href="serviceUrl">《服务协议》</a>
        </div>
      </div>

      <div class="flb-row flb-row-no-border flb-btn-group">
        <button :disabled="loginBtnDisabled" @click="login">立即登录</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, } from 'vant'
import $windowConfig from '@/fzs-public/WindowConfig'
import $httpLogin from '@/fzs-public/fzs.http/Login.Http'
import createRandom from '@/fzs-public/utils/createRandom.js'

const EMIT_ON_SUCCESS_LOGIN = 'onSuccessLogin'

export default {
  components: { },
  props: {
    cipherText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      mobile: '',
      smsCode: '',

      graphCode: '',
      graphImg: '',
      graphImgKey: '',

      timeout: 60,
      interval: null,
      intervalTxt: '获取验证码',

      agreementUrl: $windowConfig.agreementUrl,
      serviceUrl: $windowConfig.serviceUrl,
      protocolChecked: false
    }
  },
  computed: {
    loginBtnDisabled () {
      let validMobile = (this.mobile.length === 11)
      let validCode = (this.smsCode.length === 6)
      let validGraphCode = this.graphImgKey ? /^\w{4}$/.test(this.graphCode) : true
      return !(validMobile && validCode && validGraphCode)
    },

    getVerifyBtnDisabled () {
      if (this.interval) return true

      return !(this.mobile.length === 11)
    }
  },
  methods: {
    //
    validInput (type = 'mobile') {
      if (type === 'mobile') return /^1[3-9]\d{9}$/.test(this.mobile)
      if (type === 'smsCode') return /^\d{6}$/.test(this.smsCode)
    },

    //
    startCount () {
      window.clearInterval(this.interval)
      let timeout = this.timeout
      this.intervalTxt = timeout

      this.interval = window.setInterval(() => {
        timeout -= 1
        this.intervalTxt = timeout
        if (timeout <= -1) {
          this.intervalTxt = '获取验证码'

          window.clearInterval(this.interval)
          this.interval = null

          if (this.graphImgKey) {
            this.getGraphImg()
          }
        }
      }, 1000)
    },

    // 在用户多次登录失败的情况下，需要图形验证码检验
    getGraphImg () {
      this.graphImgKey = createRandom()
      this.graphImg = $httpLogin.getCaptcha(this.graphImgKey)
      this.graphCode = ''
    },

    //
    sendSmsCode () {
      if (this.interval) return
      if (!this.validInput('mobile')) return Toast('请输入正确的手机号码')

      this.smsCode = ''

      const { mobile, graphCode: validCode, graphImgKey: key } = this

      if (key && !validCode) return Toast('请输入图形验证码')

      $httpLogin.sendSmsCode({
        mobile, validCode, key
      }).then(resp => {
        const { success, message } = resp
        if (success) {
          this.startCount()
        } else {
          Toast(message || (key ? '请输入正确的图形验证码' : '请输入图形验证码'))
          this.getGraphImg()
        }
      }).catch(() => {
        this.getGraphImg()
      })
    },

    //
    login () {
      if (!this.validInput('mobile')) return Toast('请输入正确的手机号码')
      if (!this.validInput('smsCode')) return Toast('请输入正确的手机验证码')
      if (!this.protocolChecked) return Toast('请阅读并勾选隐私政策')

      if (this.cipherText) {
        this.authLoginThirdUser()
      } else {
        this.authLoginV2()
      }
    },

    // 第三方
    authLoginThirdUser () {
      const { mobile: phone, smsCode, cipherText } = this

      $httpLogin.authLoginThirdUser({
        phone, smsCode, cipherText
      }).then(resp => {
        const { message, success, valueObject = {} } = resp
        if (success) {
          const {
            authToken,
            userInfo,
            exjf,
            bocUser
          } = valueObject
          const phoneNum = userInfo.user.mobile || userInfo.user.bindMobile

          const _userInfo = {
            token: authToken,
            authToken: authToken,
            userId: exjf.userId,
            phoneNum,
            phone: phoneNum,
            bocUserCityCode: bocUser.cityCode,
            userRole: bocUser.userRole
          }

          this.$emit(EMIT_ON_SUCCESS_LOGIN, _userInfo)
        } else {
          Toast(message || '第三方解密登录失败')
        }
      })
    },

    // 普通
    authLoginV2 () {
      const { mobile, smsCode } = this

      $httpLogin.authLoginV2({
        mobile,
        smsCode,
      }).then(resp => {
        const { success, message } = resp

        if (success) {
          const {
            valueObject: {
              authToken,
              userInfo: {
                user: {
                  staffCode, fOperUserId
                } = {}
              } = {}
            } = {}
          } = resp
          this.$emit(EMIT_ON_SUCCESS_LOGIN, {
            token: authToken,
            userId: fOperUserId,
            mobile: staffCode
          })
        } else {
          Toast(message || '验证失败，请重新验证')
        }
      })
    },

    //
    toggleProtocolChecked () {
      this.protocolChecked = !this.protocolChecked
    }
  },
  mounted () {
    window.fzsL = this
  },
  created () {
  },
  watch: {}
}
</script>

<style lang="scss">
.fzs-login-box {
  $btn-sms-color: #f52d28;
  $btn-bg: linear-gradient(0deg, #ff2d39 0%, #ff7a81 100%), linear-gradient( #bd1a2f, #bd1a2f);
  $border-color: #f4dbcf;
  $input-placeholder-color: #938282;
  $input-color: #333;
  $protocol-color-1: #280606;
  $protocol-color-2: #f52d28;

  .flb-form {
    padding: 0 40px;
    .flb-row {
      border: 1PX solid $border-color;
      display: flex;
      align-items: center;
      margin-bottom: 35px;
      background-color: #fff;
      border-radius: 10px;
      padding: 0 20px 0 20px;
      box-sizing: border-box;

      .flb-icon {
        width: 50px;
        height: 50px;
        img, svg path {
          width: 100%;
        }
      }
      .flb-icon-phone {
      }
      .flb-icon-graph {
      }
      .flb-icon-code {
      }
      .flb-icon-check {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        img, img, svg path {
          width: 80%;
        }
      }
      .flb-graph {
        width: 170px;
        line-height: 100%;
        img {
          width: 100%;
        }
      }

      .flb-input {
        flex: 1;
        input {
          width: 100%;
          border: none;
          background-color: #fff;
          padding: 0 0 0 20px;
          font-size: 42px;
          &::-webkit-input-placeholder {  /* WebKit browsers*/
            color: $input-placeholder-color;
            background-color: #fff;
            font-size: 42px;
          }
        }
      }
      .flb-action {
        button {
          border: none;
          border-radius: 0;
          border-left: 1PX solid $border-color;
          color: $btn-sms-color;
          background: transparent;
          padding: 0 20px;
          &[disabled] {
            color: lighten($btn-sms-color, 30%);
          }
        }
      }
    }
    .flb-row-input {
      height: 115px;
    }
    .flb-row-protocol {
      color: $protocol-color-1;
      font-size: 32px;
      padding: 0;
      margin-bottom: 88px;
      .flb-icon {
        align-self: flex-start;
      }
      .protocol-href {
        text-align: left;
        padding: 0 0 0 20px;
        word-break: break-all;
        a {
          color: $protocol-color-2;
        }
      }
    }
    .flb-row-no-border {
      border: none;
    }
    .flb-btn-group {
      background: transparent;
      border: none;
      justify-content: center;
      margin: 0;
      button {
        font-size: 36px*1.2;
        background-image: $btn-bg;
        color: #fff;
        border: none;
        padding: 10px*2.5 20px*6;
        border-radius: 80px;
        &[disabled] {
          opacity: .7;
        }
      }

    }
  }

  // 定制化的，可根据需求改变
}
</style>

